
/*!
 * shopify-variants v1.3.0
 * (c) 2019 Pixel Union
 */

import $ from 'jquery';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Node = function () {
  function Node(variant) {
    classCallCheck(this, Node);

    this.variant = variant;
    this.optionsCount = this.variant.options.length;
    this.neighbors = [];

    for (var i = 0; i < this.optionsCount; i++) {
      this.neighbors.push([]);
    }
  }

  createClass(Node, [{
    key: "addNeighbor",
    value: function addNeighbor(variant) {
      for (var i = 0; i < this.optionsCount; i++) {
        if (this.variant.options[i] !== variant.options[i]) {
          this.neighbors[i].push(variant);
          break;
        }
      }
    }
  }, {
    key: "getValidOptions",
    value: function getValidOptions() {
      var _this = this;

      var options = [];

      var _loop = function _loop(i) {
        var variants = [_this.variant].concat(toConsumableArray(_this.neighbors[i]));
        options[i] = {};

        variants.forEach(function (item) {
          var variant = item;
          var option = variant.options[i];

          options[i][option] = {
            available: options[i][option] && options[i][option].available || variant.available
          };
        });
      };

      for (var i = 0; i < this.optionsCount; i++) {
        _loop(i);
      }

      return options;
    }
  }]);
  return Node;
}();

var Options = function () {
  function Options(product) {
    classCallCheck(this, Options);

    this.productHandle = product.handle;
    this.optionsCount = product.options.length;
    this.variants = product.variants;
    this.nodeMap = {};

    this._generateNodeMap(product);
  }

  createClass(Options, [{
    key: '_generateNodeMap',
    value: function _generateNodeMap() {
      var _this = this;

      this.variants.forEach(function (variant) {
        _this.nodeMap[variant.id] = new Node(variant);

        _this.variants.forEach(function (variant2) {
          _this.nodeMap[variant.id].addNeighbor(variant2);
        });
      });
    }
  }, {
    key: 'getVariantFromOptions',
    value: function getVariantFromOptions(options) {
      var variant = null;

      this.variants.forEach(function (potentialVariant) {
        var found = true;

        for (var i = 0; i < potentialVariant.options.length; i++) {
          if (options[i] !== potentialVariant.options[i]) {
            found = false;
          }
        }

        if (found) {
          variant = potentialVariant;
        }
      });

      return variant || false;
    }
  }, {
    key: 'getClosestVariantFromOptions',
    value: function getClosestVariantFromOptions(options) {
      var closestVariant = null;
      var matchingValues = 0;

      this.variants.forEach(function (variant) {
        var tempMatchingValues = 0;

        for (var i = 0; i < variant.options.length; i++) {
          if (options[i] === variant.options[i]) {
            tempMatchingValues++;
          } else {
            break;
          }
        }

        if (tempMatchingValues >= matchingValues) {
          closestVariant = variant;
          matchingValues = tempMatchingValues;
        }
      });

      return closestVariant ? closestVariant : false;
    }
  }, {
    key: 'getVariantOrClosestFromOptions',
    value: function getVariantOrClosestFromOptions(options) {
      return this.getVariantFromOptions(options) || this.getClosestVariantFromOptions(options);
    }
  }, {
    key: 'getAvailableOptionsFromVariant',
    value: function getAvailableOptionsFromVariant(variant) {
      return this.nodeMap[variant.id].getValidOptions();
    }
  }]);
  return Options;
}();

var Variants = function () {
  function Variants(product, $variants, $options, config) {
    classCallCheck(this, Variants);

    var defaultConfig = {
      disableUnavailableVariants: true,
      switchCallback: function switchCallback() {}
    };

    this.optionsTypes = {
      select: 'select',
      radio: 'input[type="radio"]'
    };
    this.product = product;
    this.optionsCount = this.product.options.length;
    this.$variants = $variants;
    this.$options = $options;
    this.$selectOptions = this.$options.filter(this.optionsTypes.select);
    this.$radioOptions = this.$options.filter(this.optionsTypes.radio);
    this.config = $.extend(defaultConfig, config);
    this.options = new Options(this.product);

    if (this.$selectOptions.length === 0 && this.$radioOptions.length === 0) {
      console.warn('Shopify Variants: Option set is not a valid type');
    }

    this._bindEvents();
    this._switchVariant(this._getSelectedOptions(), true);
  }

  createClass(Variants, [{
    key: 'isDefault',
    value: function isDefault() {
      return this.product.variants[0].public_title === null;
    }
  }, {
    key: 'getSelectedVariant',
    value: function getSelectedVariant() {
      if (this.isDefault()) {
        return this.product.variants[0];
      }

      return this.options.getVariantFromOptions(this._getSelectedOptions());
    }
  }, {
    key: 'unload',
    value: function unload() {
      this._unbindEvents();
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      var _this = this;

      this.$options.on('change.variants', function (event) {
        var $target = $(event.target);

        if ($target.is(_this.optionsTypes.select)) {
          _this._switchVariant(_this._getSelectedOptionsSelect());
        } else if ($target.is(_this.optionsTypes.radio)) {
          _this._switchVariant(_this._getSelectedOptionsRadio());
        }
      });
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$options.off('change.variants');
    }
  }, {
    key: '_getSelectedOptions',
    value: function _getSelectedOptions() {
      // Note that we only support selects, radios, or both (complete sets of each),
      // but not half and half. So we never want to return the selected options
      // from both types. We can/do assume that all controls are in sync, because
      // shopify-variants keeps them that way.
      if (this.$selectOptions.length > 0) {
        return this._getSelectedOptionsSelect();
      }

      if (this.$radioOptions.length > 0) {
        return this._getSelectedOptionsRadio();
      }

      return [];
    }
  }, {
    key: '_getSelectedOptionsSelect',
    value: function _getSelectedOptionsSelect() {
      var options = [];

      this.$selectOptions.each(function (i, option) {
        options.push(option.value);
      });

      return options;
    }
  }, {
    key: '_getSelectedOptionsRadio',
    value: function _getSelectedOptionsRadio() {
      var options = [];

      this.$radioOptions.each(function (i, option) {
        if ($(option).is(':checked')) {
          options.push(option.value);
        }
      });

      return options;
    }
  }, {
    key: '_switchVariant',
    value: function _switchVariant() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._getSelectedOptions();
      var firstLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var product = this.product;

      var variant = null;
      var availableOptions = null;

      variant = this.options.getVariantOrClosestFromOptions(options);

      if (!variant) {
        return;
      }

      availableOptions = this.options.getAvailableOptionsFromVariant(variant);

      this._switchVariantSelect(variant, availableOptions);
      this._switchVariantRadio(variant, availableOptions);

      this.$variants.val(variant.id);

      var data = {
        product: product,
        variant: variant,
        firstLoad: firstLoad
      };

      this.config.switchCallback(data);
      $(window).trigger('shopify-variants:switch-variant', data);
    }
  }, {
    key: '_switchVariantSelect',
    value: function _switchVariantSelect(variant, availableOptions) {
      var _this2 = this;

      if (this.$selectOptions.length === 0) {
        return;
      }

      // Iterate over each option type

      var _loop = function _loop(i) {
        // Corresponding select dropdown
        var $input = $(_this2.$selectOptions[i]);

        // Iterate over each option on dropdown
        $input.find('option').each(function (index, option) {
          var $option = $(option);
          var value = option.value;

          // Not an available option

          $option.prop('disabled', !availableOptions[i][value] || !availableOptions[i][value].available && _this2.config.disableUnavailableVariants).prop('selected', false);

          // Dropdown option matches variant option
          if (variant.options[i] === value) {
            $option.prop('disabled', false).prop('selected', true);
          }
        });
      };

      for (var i = 0; i < this.product.options.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: '_switchVariantRadio',
    value: function _switchVariantRadio(variant, availableOptions) {
      var _this3 = this;

      if (this.$radioOptions.length === 0) {
        return;
      }

      this.$radioOptions.attr('disabled', true).prop('checked', false).attr('data-soldout', false);

      var _loop2 = function _loop2(i) {
        var selector = encodeURIComponent(_this3.product.options[i]).replace(/%20/g, '+').replace(/[!'()*]/g, function (char) {
          return '%' + char.charCodeAt(0).toString(16).toUpperCase();
        });

        var $options = _this3.$radioOptions.filter('[name="' + selector + '"]');
        $options.each(function (index, option) {
          var $option = $(option);

          if (variant.options[i] === $option.val()) {
            $option.prop('checked', true);
          }

          if (availableOptions[i][$option.val()]) {
            $option.attr('disabled', false);

            if (!availableOptions[i][$option.val()].available && _this3.config.disableUnavailableVariants) {
              $option.attr('disabled', true);
              $option.attr('data-soldout', true);
            }
          }
        });
      };

      for (var i = 0; i < this.product.options.length; i++) {
        _loop2(i);
      }
    }
  }]);
  return Variants;
}();

export default Variants;
